import { motion } from "framer-motion";
import { fadeIn } from "../utils/framer";
import { useState, useEffect } from "react";

const Equipo = () => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <h1 className="text-3xl text-center sm:text-left mb-8 md:mx-48 sm:mx-6">Fundadora ———</h1>
      <section className="w-full bg-gradient-to-r from-gray-800 to-gray-500 text-white py-5">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center">
          {/* Imagen alineada a la izquierda y pegada abajo */}
          <div className="w-full md:w-[45%] flex justify-center md:justify-start">
            <img
              src="/equipo3.jpg"
              alt="Gisela Barbero"
              className="max-w-full max-h-[500px] object-contain bg-transparent self-end"
            />
          </div>

          {/* Texto alineado a la derecha */}
          {isMobile ? (
            <div className="w-full md:w-[50%] text-center md:text-left md:ml-1 ml-1">
              <h2 className="text-2xl sm:text-3xl font-semibold leading-snug">
                Abogada especialista en familia y en defensa técnica de niños,
                niñas y adolescentes. Sucesiones. Civil. Asesoramiento
                y realización de trámites registrales inmobiliarios y del
                automotor.
              </h2>
              <p className="mt-4 font-bold text-lg">
                Gisela Barbero, Fundadora
              </p>
            </div>
          ) : (
            <motion.div
              variants={fadeIn("right", 0.3)}
              initial="hidden"
              whileInView="show"
              viewport={{ once: false, amount: 0.7 }}
              className="w-full md:w-[50%] text-center md:text-left md:ml-8"
            >
              <h2 className="text-2xl sm:text-3xl font-semibold leading-snug">
                Abogada especialista en familia y en defensa técnica de niños,
                niñas y adolescentes. Sucesiones. Civil. Asesoramiento
                y realización de trámites registrales inmobiliarios y del
                automotor.
              </h2>
              <p className="mt-4 font-bold text-lg">
                Gisela Barbero - Fundadora
              </p>
            </motion.div>
          )}
        </div>
      </section>
    </>
  );
};

export default Equipo;
